import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.OUT.enumeration<
    graphql.schema.ProcessActivityType,
    ents.core.relay.processes.Activity.Type
  >({
    [graphql.schema.ProcessActivityType.ParsingExcelWorkbook]:
      ents.core.relay.processes.Activity.Type.ParsingExcelWorkbook,
    [graphql.schema.ProcessActivityType.PuttingDmsRecords]:
      ents.core.relay.processes.Activity.Type.PuttingDmsRecords,
    [graphql.schema.ProcessActivityType.RetrievingS3Object]:
      ents.core.relay.processes.Activity.Type.RetrievingS3Object,
    [graphql.schema.ProcessActivityType.RateCalcAllocations]:
      ents.core.relay.processes.Activity.Type.RateCalculateAllocations,
    [graphql.schema.ProcessActivityType.RateCalcPools]:
      ents.core.relay.processes.Activity.Type.RateCalculatePools,
    [graphql.schema.ProcessActivityType.RateGenReportContent]:
      ents.core.relay.processes.Activity.Type.RateGenerateReportContent,
    [graphql.schema.ProcessActivityType.RateRefreshGlRecords]:
      ents.core.relay.processes.Activity.Type.RateRefreshGlRecords,
    [graphql.schema.ProcessActivityType.RateWriteGlRecordsToDms]:
      ents.core.relay.processes.Activity.Type.RateWriteGlRecordsToDms,
    [graphql.schema.ProcessActivityType.ExtractingDmsRecordsFromExcelWorksheet]:
      ents.core.relay.processes.Activity.Type
        .ExtractingDmsRecordsFromExcelWorksheet,
    [graphql.schema.ProcessActivityType.ScenarioAddToList]:
      ents.core.relay.processes.Activity.Type.ScenarioAddToList,
    [graphql.schema.ProcessActivityType.ScenarioAssigningUser]:
      ents.core.relay.processes.Activity.Type.ScenarioAssigningUser,
    [graphql.schema.ProcessActivityType.ScenarioImporting]:
      ents.core.relay.processes.Activity.Type.ScenarioImporting,
    [graphql.schema.ProcessActivityType.ScenarioSettingUp]:
      ents.core.relay.processes.Activity.Type.ScenarioSettingUp,
    [graphql.schema.ProcessActivityType.GenerateFileContent]:
      ents.core.relay.processes.Activity.Type.GeneratingFileContent,
    [graphql.schema.ProcessActivityType.RenderFile]:
      ents.core.relay.processes.Activity.Type.RenderingFile,
    [graphql.schema.ProcessActivityType.StoreFile]:
      ents.core.relay.processes.Activity.Type.StoringFile,
  }),
  graphql.transformers.IN.enumeration<
    ents.core.relay.processes.Activity.Type,
    graphql.schema.ProcessActivityType
  >({
    [ents.core.relay.processes.Activity.Type.ParsingExcelWorkbook]:
      graphql.schema.ProcessActivityType.ParsingExcelWorkbook,
    [ents.core.relay.processes.Activity.Type.PuttingDmsRecords]:
      graphql.schema.ProcessActivityType.PuttingDmsRecords,
    [ents.core.relay.processes.Activity.Type.RetrievingS3Object]:
      graphql.schema.ProcessActivityType.RetrievingS3Object,
    [ents.core.relay.processes.Activity.Type.RateCalculateAllocations]:
      graphql.schema.ProcessActivityType.RateCalcAllocations,
    [ents.core.relay.processes.Activity.Type.RateCalculatePools]:
      graphql.schema.ProcessActivityType.RateCalcPools,
    [ents.core.relay.processes.Activity.Type.RateGenerateReportContent]:
      graphql.schema.ProcessActivityType.RateGenReportContent,
    [ents.core.relay.processes.Activity.Type.RateRefreshGlRecords]:
      graphql.schema.ProcessActivityType.RateRefreshGlRecords,
    [ents.core.relay.processes.Activity.Type.RateWriteGlRecordsToDms]:
      graphql.schema.ProcessActivityType.RateWriteGlRecordsToDms,
    [ents.core.relay.processes.Activity.Type
      .ExtractingDmsRecordsFromExcelWorksheet]:
      graphql.schema.ProcessActivityType.ExtractingDmsRecordsFromExcelWorksheet,
    [ents.core.relay.processes.Activity.Type.ScenarioAddToList]:
      graphql.schema.ProcessActivityType.ScenarioAddToList,
    [ents.core.relay.processes.Activity.Type.ScenarioAssigningUser]:
      graphql.schema.ProcessActivityType.ScenarioAssigningUser,
    [ents.core.relay.processes.Activity.Type.ScenarioImporting]:
      graphql.schema.ProcessActivityType.ScenarioImporting,
    [ents.core.relay.processes.Activity.Type.ScenarioSettingUp]:
      graphql.schema.ProcessActivityType.ScenarioSettingUp,
    [ents.core.relay.processes.Activity.Type.GeneratingFileContent]:
      graphql.schema.ProcessActivityType.GenerateFileContent,
    [ents.core.relay.processes.Activity.Type.RenderingFile]:
      graphql.schema.ProcessActivityType.RenderFile,
    [ents.core.relay.processes.Activity.Type.StoringFile]:
      graphql.schema.ProcessActivityType.StoreFile,
  }),
)
